import { Link, useDisclosure, VStack } from '@chakra-ui/react';
import { Permission } from '@tp-vision/roles-permissions';
import { t } from 'i18next';
import { useAuth } from '~auth/useAuth';
import { EmptyView, EmptyViewButton } from '~components/EmptyView';
import { HelpIcon } from '~components/ui/icons';
import { EmptyConfigurationIllustration } from '~components/ui/illustrations/EmptyConfigurationIllustration';
import { CreateConfigFromTemplateModal } from './CreateConfigurationFromTemplateWizard';

export function EmptyConfigurations() {
  const createConfigFromTemplateModal = useDisclosure();
  const { verifyUserPermissions } = useAuth();
  const canCreateConfiguration = verifyUserPermissions([Permission.ConfigurationCreate]);

  return (
    <VStack paddingTop={20} paddingBottom={20} spacing={8}>
      <EmptyView
        icon={<EmptyConfigurationIllustration />}
        title={t('createFirstConfig')}
        description={t('createFirstConfigDesc')}
        padding="0"
      >
        <EmptyViewButton
          label={`+ ${t('newConfiguration')}`}
          onClick={createConfigFromTemplateModal.onOpen}
          isDisabled={!canCreateConfiguration}
        />
      </EmptyView>
      <Link
        isExternal
        href="https://docs.wave.ppds.com/"
        color="blue.500"
        target="_blank"
        rel="noreferrer"
        display="flex"
        alignItems="center"
      >
        <HelpIcon color="blue.500" width={5} height={5} marginRight={2} />
        {t('needHelp')}
      </Link>
      {createConfigFromTemplateModal.isOpen && (
        <CreateConfigFromTemplateModal
          isOpen={createConfigFromTemplateModal.isOpen}
          onCancel={createConfigFromTemplateModal.onClose}
        />
      )}
    </VStack>
  );
}
